<template>
  <div class="my-order" ref="container">
    <div class="header bg-color-red">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="text">
          <div class="name">扫码收款订单信息</div>
          <!-- <div>
            累计订单：{{ orderData.order_count || 0 }}
			总消费：￥{{ orderData.sum_price || 0 }}
          </div> -->
        </div>
        <div class="pictrue"><img src="@assets/images/orderTime.png" /></div>
	  </div>
    </div>
    <div class="nav acea-row row-around">
	  <div
	    class="item"
	    :class="{ on: type === 999 }"
	    @click="$router.replace({ path: '/user/collection_list/999' })"
	  >
	    <div>全部</div>
	    <div class="num">{{ orderData.total_count || 0 }}</div>
	  </div>
      <div
        class="item"
        :class="{ on: type === 1 }"
        @click="$router.replace({ path: '/user/collection_list/1' })"
      >
        <div>待支付</div>
        <div class="num">{{ orderData.unpaid_count || 0 }}</div>
      </div>
      <div
        class="item"
        :class="{ on: type === 2 }"
        @click="$router.replace({ path: '/user/collection_list/2' })"
      >
        <div>已完成</div>
        <div class="num">{{ orderData.complete_count || 0 }}</div>
      </div>
	  <div
	    class="item"
	    :class="{ on: type === 3 }"
	    @click="$router.replace({ path: '/user/collection_list/3' })"
	  >
	    <div>已退款</div>
	    <div class="num">{{ orderData.y_refund_count || 0 }}</div>
	  </div>
    </div>
    <div class="list">
	  <!-- 搜索 -->
	  <form @submit.prevent="search()">
		  <div class="search-wapper" v-if="type == 999">
			<input type="text" v-model="keyword" placeholder="搜索订单号">
			<span class="iconfont icon-sousuo" @click="search()"></span>
		  </div>
	  </form>
      <div class="item" v-for="order in orderList" :key="order.id">
        <div class="title acea-row row-between-wrapper">
          <div class="acea-row row-middle">
            {{order.type_name}}：{{ order.collection_id }}
          </div>
          <div :class="order.status_name == '已支付'  ? 'font-color-green' : 'font-color-red1'">
			{{ order.status_name }}
		  </div>
        </div>
		<div class="text acea-row row-between collection-item1">
		  <div class="name line2 font-color-red">￥{{ order.pay_price }}</div>
		  <div class="money font-color-gray">{{ order.pay_type_name }}</div>
		</div>
		<div class="collection-item2">
		  <div class="money font-color-gray">{{ order.pay_time }}</div>
		  <div class="name line2 font-color-gray">{{ order.store_name }}-{{ order.clerk_name }}</div>
		</div>
      </div>
    </div>
    <div class="noCart" v-if="orderList.length === 0 && page > 1">
      <div class="pictrue"><img src="@assets/images/noOrder.png" /></div>
    </div>
	<div class="footer-scan-btn-wapper">
	<!-- <div class="footer-scan-btn-wapper" v-if="iswechat"> -->
		<div class="footer-scan-btn" @click="$router.replace({ path: '/user/collection/Scan' })">
			扫码收款
		</div>
	</div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
    
    <GeneralWindow
      :generalActive="generalActive"
      @closeGeneralWindow="closeGeneralWindow"
      :generalContent="generalContent"
    ></GeneralWindow>
  </div>
</template>
<script>
import { collectionOrderData, collectionOrderList, cashierOrderScan } from "@api/order";
import {
  cancelOrderHandle,
  payOrderHandle,
  takeOrderHandle
} from "@libs/order";
import Loading from "@components/Loading";
import { mapGetters } from "vuex";
import {  parseQuery } from "@utils";
import { wechatEvevt } from "@libs/wechat";
import GeneralWindow from "@components/GeneralWindow";
import Vue from "vue";
import cookie from "@utils/store/cookie";

const STATUS = [
  "待付款",
  "待发货",
  "待收货",
  "待评价",
  "已完成",
  "",
  "",
  "",
  "",
  "待付款"
];
 
const NAME = "CollectionList";

export default {
  name: NAME,
  data() {
    return {
	  iswechat: this.$wechat.isWeixin(),
      offlinePayStatus: 2,
      orderData: {},
      type: parseInt(this.$route.params.type) || 0,
      page: 1,
      limit: 10,
	  keyword: "",//搜索
      loaded: false,
      loading: false,
      orderList: [],
      pay: false,
      payType: [ "alipay", "weixin", "offline"],
      from: this.$wechat.isWeixin()? "weixin" : "weixinh5",
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: ""
      },
	  //扫码退款
	  verify_code: "",
	  isRefundMask: false,
	  refund_info: {},
	  refund_type: 1,
	  refund_price: "",
	  fixed_price: "",
	  isPrice: true
    };
  },
  components: {
    Loading,
    GeneralWindow
  },
  computed: mapGetters(["userInfo"]),
  watch: {
    $route(n) {
      if (n.name === NAME) {
        const type = parseInt(this.$route.params.type) || 0;
        if (this.type !== type) {
          this.changeType(type);
        }
        this.getOrderData();
      }
    }
  },
  mounted() {
    this.getOrderData();
    this.getOrderList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getOrderList();
    });
  },
  methods: {
    getOrderData() {
      collectionOrderData().then(res => {
        this.orderData = res.data;
      });
    },
    closeGeneralWindow(msg) {
      this.generalActive = msg;
      this.reload();
      this.getOrderData();
    },
    reload() {
      this.changeType(this.type);
    },
    changeType(type) {
      this.type = type;
      this.orderList = [];
      this.page = 1;
      this.loaded = false;
      this.loading = false;
      this.getOrderList();
    },
	//搜索订单号
	search(){
		this.orderList = [];
		this.page = 1;
		this.loaded = false;
		this.loading = false;
		this.getOrderList();
	},
    getOrderList() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      const { page, limit, type, keyword } = this;
      collectionOrderList({
        page,
        limit,
        status: type == 999 ? '' : type,
		keyword
      }).then(res => {
		  console.log(res.data.data)
        this.orderList = this.orderList.concat(res.data.data);
        this.page++;
        this.loaded = res.data.length < this.limit;
        this.loading = false;
      });
    },
  }
};
</script>

<style scoped>
.search-wapper{
	width: 100%;
	background-color: #fff;
	border-radius: 15px;
	padding: 0.1rem 0.1rem 0.1rem 0.2rem;
	display: flex;
	justify-content: left;
	align-items: center;
	margin-bottom: 0.14rem;
}
.search-wapper .iconfont{
	margin-right: 0.1rem;
	color: #777;
}
.search-wapper input{
	width: 100%;
}
.search-wapper input::placeholder{
	color: #999;
	font-size: 0.26rem;
}
.my-order .list{
	margin-bottom: 1.2rem;
}
.noCart {
  margin-top: 0.17rem;
  padding-top: 0.1rem;
}

.noCart .pictrue {
  width: 4rem;
  height: 3rem;
  margin: 0.7rem auto 0.5rem auto;
}

.noCart .pictrue img {
  width: 100%;
  height: 100%;
}
.footer-scan-btn-wapper{
	position: fixed;
	left: 0;
	bottom: 0;
	background-color: #fff;
	width: 100%;
	padding: 0.2rem 0;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	box-shadow: 0 0 5px 0 #eee;
}
.footer-scan-btn{
	color: #fff;
	background-color: #e93323;
	border-radius: 0.5rem;
	margin-right: 0.2rem;
	padding: 0.1rem 0.3rem;
}
.my-order .list .item .bottom{
	height: auto;
}
.my-order .list .item .bottom .bnt{
	margin: 0.2rem 0;
}
.mask {
	width: 100%;
	height: 100%;
	background: rgba(0,0,0,0.5);
	display: flex;
	justify-content: center;
	align-items: center;
}
.refund-Popup{
	background-color: #fff;
	width: 80%;
	border-radius: 8px;
}
.refund-Popup-title{
	height: 1rem;
	line-height: 1rem;
	text-align: center;
	border-bottom: 1px solid #ccc;
	font-weight: bold;
	font-size: 0.3rem;
}
.refund-radio{
	padding: 0.2rem;
	display: flex;
	justify-content: center;
	align-items: center;
}
.refund-radio-for{
	position: relative;
	width: 38%;
}
.refund-radio-for span{
	position: absolute;
	left: 0.4rem;
	top: 0.01rem;
	width: 1.5rem;
}
input[type="radio"] {
	width: 0.3rem;
	height: 0.3rem;
	opacity: 0;
}
label {
	position: absolute;
	left: 0;
	top: 0.06rem;
	width: 0.3rem;
	height: 0.3rem;
	border-radius: 50%;
	border: 1px solid #999;
	cursor: pointer;
	display: inline-block;
	margin-right: 0.1rem;
}
input[type="radio"]:checked+label { 
	background-color: #e93323;
	border: 1px solid #e93323;
}
input[type="radio"]:checked+label::after {
	position: absolute;
	content: "";
	width: 0.09rem;
	height: 0.17rem;
	top: 0.02rem;
	left: 0.09rem;
	border: 2px solid #fff;
	border-top: none;
	border-left: none;
	transform: rotate(45deg);
}
.refund-price{
	padding: 0 0.2rem;
	display: flex;
	justify-content: center;
	align-items: center;
}
.refund-price input{
	border: 1px solid #ccc;
	text-indent: 0.2rem;
}
.refund-btn-wapper{
	margin: 0.3rem auto;
	margin-top: 0.5rem;
	display: flex;
	justify-content: center;
	align-items: center;
}
.refund-btn{
	padding: 0.1rem 0.5rem;
	background-color: #e93323;
	color: #fff;
	border-radius: 7px;
	border: 1px solid #e93323;
}
.refund-btn-wapper .cancel{
	margin-left: 0.6rem;
	background-color: #fff;
	color: #e93323;
}
.my-order .list .item .title{
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.acea-row.row-middle{
	width: 85%;
}
.collection-item1{
	padding: 0 0.3rem;
	margin-top: 0.2rem;
}
.font-color-gray{
	color: #777;
	font-size: 0.26rem;
}
.font-color-green{
	background-color: #4e9249;
	color: #fff;
	font-size: 0.24rem;
	border-radius: 5px;
	width: 0.9rem;
	height: 0.4rem;
	text-align: center;
	line-height: 0.4rem;
	overflow: hidden;
}
.font-color-red1{
	background-color: #dd4235;
	color: #fff;
	font-size: 0.24rem;
	border-radius: 5px;
	width: 0.9rem;
	height: 0.4rem;
	text-align: center;
	line-height: 0.4rem;
	overflow: hidden;
}
.collection-item2{
	float: right;
	padding: 0 0.3rem;
	margin-bottom: 0.2rem;
}
.collection-item2 div{
	text-align: right;
	margin-top: 0.1rem;
}
.my-order .list .item{
	overflow: hidden;
}
.collection-item1 .name{
	font-size: 0.32rem;
}
.Loads{
	opacity: 0;
}
</style>
